// O componente agora renderiza com efeito glass customizado,
// que é estilizado pelo CSS para ser fixo na parte inferior.
function Footer() {
  return (
    <div className="unitec-credit footer-glass">
      Desenvolvido pela Unidade de Tecnologia da Informação e Comunicação - UNITEC
    </div>
  );
}

export default Footer;